import { MissionDataSet } from '../DataSet/Mission';
import { IDataHandler } from '../IDataHandler';
import { MissionTrackingEventName } from '../TrackingEvent';

export const MissionEventDataMap: {
    [key in MissionTrackingEventName]: (keyof MissionDataSet)[];
} = {
    [MissionTrackingEventName.missionCompleted]: [
        'mLevel',
        'mRetryNum',
        'mIsSuccessRetry',
        'mLevelMoves',
        'mHighestPlayStreak',
        'mChangerUsed',
        'mRemoveOneUsed',
        'mMassRemoveUsed',
        'mFreeEntryUsed',
        'mPlus5Used',
        'mJokerUsed',
        'mUndoUsed',
        'mExtraCardsBought',
        'mExtraCardsWon',
        'mJokerCardsWon',
        'mCoinsSpent',
        'mFriendHelped',
        'mFriendWhoHelped',
        'mStars',
        'mLossAversionCoinsSpent',
        'mScore',
        'mScoreBeforeEndSequence',
        'mMovesLeft',
        'mMovesMade',
        'mNumBoostersUsedLossAversion',
        'mCoinsBoughtWithAds',
        'mChestStarsGained',
        'mChestStarsToGain',
        'mCardsLeftOnBoard',
        'mRemoveCardsBoostersUsed',
        'mExtraWildcardsBoostersUsed',
        'mCanisterCardBoostersUsed',
        'mCoinsBoughtWithRealMoney',
        'mBoostersBoughtWithRealMoney',
        'mEntryCoinCost',
        'mEntryWithBooster',
        'mStreakNum',
        'mStreakColorNum',
    ],
    [MissionTrackingEventName.missionStarted]: [
        'mLevel',
        'mRetryNum',
        'mIsSuccessRetry',
        'mLevelMoves',
        'mChestStarsToGain',
        'mRemoveCardsBoostersUsed',
        'mExtraWildcardsBoostersUsed',
        'mCanisterCardBoostersUsed',
        'mEntryCoinCost',
        'mEntryWithBooster',
    ],
    [MissionTrackingEventName.missionFailed]: [
        'mLevel',
        'mRetryNum',
        'mIsSuccessRetry',
        'mLevelMoves',
        'mHighestPlayStreak',
        'mChangerUsed',
        'mRemoveOneUsed',
        'mMassRemoveUsed',
        'mFreeEntryUsed',
        'mPlus5Used',
        'mJokerUsed',
        'mUndoUsed',
        'mExtraCardsBought',
        'mExtraCardsWon',
        'mJokerCardsWon',
        'mCoinsSpent',
        'mFriendHelped',
        'mFriendWhoHelped',
        'mStars',
        'mLossAversionCoinsSpent',
        'mScore',
        'mScoreBeforeEndSequence',
        'mMovesLeft',
        'mMovesMade',
        'mNumBoostersUsedLossAversion',
        'mCoinsBoughtWithAds',
        'mCardsLeftOnBoard',
        'mRemoveCardsBoostersUsed',
        'mExtraWildcardsBoostersUsed',
        'mCanisterCardBoostersUsed',
        'mCoinsBoughtWithRealMoney',
        'mBoostersBoughtWithRealMoney',
        'mEntryCoinCost',
        'mEntryWithBooster',
        'mStreakNum',
        'mStreakColorNum',
    ],
};

export class MissionDataHandler implements IDataHandler<MissionDataSet> {
    public data: MissionDataSet = new MissionDataSet();

    public getEventData(eventName: MissionTrackingEventName): MissionDataSet {
        const data = MissionEventDataMap[eventName].reduce((acc, key) => {
            acc[key] = this.data[key] as never;
            return acc;
        }, {} as MissionDataSet);

        // Reset mission data.
        if (
            eventName === MissionTrackingEventName.missionCompleted ||
            eventName === MissionTrackingEventName.missionFailed
        ) {
            this.data = new MissionDataSet();
        }

        if (eventName === MissionTrackingEventName.missionStarted) {
            this.data.mCoinsBoughtWithRealMoney = 0;
            this.data.mBoostersBoughtWithRealMoney = 0;
        }

        return data;
    }

    public clearData(): void {
        this.data = new MissionDataSet();
    }
}
